import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import { NotificationManager } from 'react-notifications';

// Services
import customersService from "@services/customers";

// Components
import POSPage from '@components/POSPage'
import Cards from '@components/Cards'
import paginator from '@utils/paginator'

import { EventBus as eventBus } from "@components/EventBus";

class Page extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pagination: {
                left: {
                    first: {
                        click: () => this.setState({ page: 1 }),
                        show: true,
                    },
                    previous: {
                        click: () => this.setState({ page: this.state.page - 1 }),
                        show: true,
                    }
                },
                right: {
                    next: {
                        click: () => this.setState({ page: this.state.page + 1 }),
                        show: true,
                    },
                    last: {
                        click: () => this.setState({ page: this.state.lastPage }),
                        show: true,
                    }
                }
            },
            filters: [{
                label: 'Nome',
                field: 'name',
                value: '',
                placeholder: 'Pesquise pelo Nome',
                handleChange: (e) => this.handleChange(e),
            }, {
                label: 'Email',
                field: 'email',
                value: '',
                placeholder: 'Pesquise pelo Email',
                handleChange: (e) => this.handleChange(e),
            }, {
                label: 'Telefone',
                field: 'phone',
                value: '',
                placeholder: 'Pesquise pelo Telefone',
                handleChange: (e) => this.handleChange(e),
            }],
            items: [],
            page: 1,
            lastPage: 0,
            pageSize: 24,
            loaded: false,
        };

        this.loadFunction = this.loadFunction.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.setState({ filters: this.state.filters.map((filter) => {
            return {
                ...filter,
                value: e.target.name === filter.field ? e.target.value : filter.value,
            }
        }) });
    }

    async loadFunction() {
        if (!this.state.loaded) {
            try {
                const idempresa = this.props.cookies.get('member_idempresa');
                const customers = await customersService.get(idempresa);

                const enrichedCustomers = customers.map((customer) => ({
                        ...customer,
                        icon: 'fa-user',
                        text: customer.name,
                        click: () => eventBus.$emit("SET/steps/form", { customer }),
                }));

                const lastPage = Math.ceil(enrichedCustomers.length / this.state.pageSize);

                this.setState({ items: enrichedCustomers, lastPage, loaded: true });
            } catch (error) {
                console.error('Erro ao carregar clientes:', error);
                NotificationManager.error('Erro ao carregar clientes', 'Clientes');
            }
        }
    }
    
    render () {
        const { items, filters, pagination, page, pageSize } = this.state;
        const { form } = this.props;
        const filteredItems = items.filter((item) => {
            return filters
                .every((filter) =>
                    filter.value
                    ? filter.value.split(' ')
                        .every((filterValue) => 
                            item[filter.field].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                                .includes(filterValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
                        )
                    : true
                );
        });
        
        const pageInfo = paginator(filteredItems, page, pageSize);

        const realPagination = {
            left: pageInfo.pre_page ? pagination.left : { first: {}, previous: {} },
            right: pageInfo.next_page ? pagination.right : { next: {}, last: {} },
        }

        const data = pageInfo.data.map((item) => ({ ...item, active: item.idcustomer === form.customer.idcustomer}))

        return (
            <POSPage
                pagination={ realPagination }
                filters={ filters }
                loadFunction={ this.loadFunction }
            >
                <Cards modifier="small" items={ data } />
            </POSPage>
        );
    }
}

export default withCookies(Page);